import * as React from 'react'
import { CampaignCardTemplate, ClientCampaignCard } from '/fiweb/components/CampaignCard'
import { useGetCampaignCardDataQuery } from '/~/types/graphql'
import Skeleton from './Skeleton'
import { normalizeCardData } from './normalizeCardData'
import { gtmEventSelectItem } from '/~/utils/googleTagManager'
import { useServerTimeSync } from '/~/utils/TimeSyncProvider'

interface Props {
  cardData: ClientCampaignCard
  clickNavigatesTo?: string
  campaignToolMode?: boolean
}

export const OldApiCampaignCard = ({ cardData, clickNavigatesTo, campaignToolMode }: Props) => {
  const { serverTimeOffset } = useServerTimeSync()
  const { data, loading: campaignDataLoading } = useGetCampaignCardDataQuery({
    variables: { campaignId: cardData.id },
    skip: !!cardData.finishedCampaignData,
  })

  if (campaignDataLoading) {
    return <Skeleton />
  }

  const normalizedData = normalizeCardData({
    campaignData: data?.reducedCampaignDataForCampaignCard || cardData?.finishedCampaignData,
    cardData,
    visitorSettings: data?.visitorSettings,
    campaignToolMode,
    serverTimeOffset,
    clickNavigatesTo,
  })

  return (
    <CampaignCardTemplate
      {...normalizedData}
      onClick={() => normalizedData?.clickNavigatesTo && gtmEventSelectItem(normalizedData)}
    />
  )
}
